import { useTranslation } from "react-i18next";
import React, { ChangeEvent, FunctionComponent, KeyboardEvent } from "react";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  MenuProps,
  Row,
  TableColumnType,
  Typography,
} from "antd";

import FormInput from "../../../form-input/FormInput";
import "./filter-table.scss";
import {
  DownOutlined,
  PlusOutlined,
  SearchOutlined,
  SettingOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { DataType } from "../../../../types/assign-course-construction";
import { CheckboxOptionType } from "antd/lib";
import FormItemDropdown from "../../../form-dropdown/FormItemDropdown";

type FilterTableProps = {
  handleOpen: () => void;
  setlastPreview: (value: any) => void;
  searchValue: string;
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void;
  handleSubmitSearch: () => void;
  handleOpenFilter: () => void;
  checkedList: Array<string>;
  setCheckedList: (value: string[]) => void;
  dataColumns: TableColumnType<DataType>[];
  selectedRowKeys: React.Key[];
  tab: string
};

const FilterDataContentForum: FunctionComponent<FilterTableProps> = ({
  handleOpen,
  searchValue,
  handleChangeInput,
  handleSearch,
  handleSubmitSearch,
  handleOpenFilter,
  dataColumns,
  checkedList,
  setCheckedList,
  selectedRowKeys,
  setlastPreview,
  tab
}) => {
  const { t } = useTranslation();
  const options = dataColumns.map(({ key, title }) => ({
    label: title,
    value: key,
  }));

  const items: MenuProps["items"] = [
    {
      label: (
        <Checkbox.Group
          options={options as CheckboxOptionType[]}
          value={checkedList}
          onChange={(value) => {
            setCheckedList(value as string[]);
          }}
        />
      ),
      key: "radio",
    },
  ];

  const menuProps = {
    items,
  };

  const option = [
    {
      id: 1,
      name: t("Xem nhiều", "Xem nhiều")
    },
    {
      id: 2,
      name: t("Xem gần đây", "Xem gần đây")
    }
  ]

  return (
    <>
      <div className="heading-extra">
        <Row gutter={[{ md: 8, xl: 8, xs: 8 }, 8]} className="row-filter">
          <Col
            md={{ span: 5 }}
            lg={{ span: 5 }}
            xl={{ span: 5 }}
            xs={{ span: 7 }}
            className="filter-group-select"
          >
            <FormItemDropdown
              options={option}
              allowClear={true}
              placeholder={t("Sắp xếp theo", "Sắp xếp theo")}
              onChange={(e) => setlastPreview(e)}
            />
          </Col>
          <Col
            md={{ span: 3 }}
            lg={{ span: 3 }}
            xl={{ span: 3 }}
            xs={{ span: 7 }}
            className="filter-group-select"
          >
            <div className="heading-filter">
              <Button className="filter-button" onClick={handleOpenFilter}>
                <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
                <DownOutlined />
              </Button>
            </div>
          </Col>
          <Col
            md={{ span: 8 }}
            lg={{ span: 8 }}
            xl={{ span: 8 }}
            xs={{ span: 8 }}
          >
            <div className="heading-search">
              <FormInput
                placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
                value={searchValue}
                onChange={handleChangeInput}
                onKeyPress={handleSearch}
                afterPrefixIcon={
                  <SearchOutlined onClick={handleSubmitSearch} />
                }
              />
            </div>
          </Col>
          <Col
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xs={{ span: 21 }}
          >
            <div className="heading-resigter">
              <Button onClick={handleOpen} className="btn btn-primary">
                <PlusOutlined />
                <Typography.Text>{t("Thêm chủ đề", "Thêm chủ đề")}</Typography.Text>
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FilterDataContentForum;